import { Button, Stack, Typography } from "@octopus-energy/coral/atoms"
import {
    Footer,
    FooterCountryList,
    FooterList,
    FooterListContainer,
    FooterSocialLink,
    FooterSocialList,
    FooterText,
} from "@octopus-energy/coral/organisms"
import { useTranslations } from "next-intl"
import { useOfficeAddress } from "@/features/addresses"
import { useSocialLinks } from "@/features/navigation/hooks/useSocialLinks"
import { useCenterMenu } from "./hooks/useCenterMenu"
import { useLeftMenu } from "./hooks/useLeftMenu"

interface AppFooterProps {
    isNavless?: boolean
}

export const AppFooter = ({ isNavless }: AppFooterProps) => {
    const centerMenu = useCenterMenu()
    const leftMenu = useLeftMenu()
    const socialLinks = useSocialLinks()
    const { fullAddress } = useOfficeAddress()
    const t = useTranslations("AppFooter")

    if (isNavless) {
        return null
    }

    return (
        <Footer>
            <FooterListContainer>
                <FooterList>
                    {leftMenu.map((item) => (
                        <Button
                            key={item.label}
                            color="base100"
                            variant="text"
                            href={item.href}
                        >
                            <Typography
                                component="span"
                                textAlign="left"
                                textStyle="h6"
                                color="inherit"
                            >
                                {item.label}
                            </Typography>
                        </Button>
                    ))}
                </FooterList>
                <FooterList>
                    {centerMenu.map((item) => (
                        <Button
                            key={item.label}
                            color="base100"
                            variant="text"
                            href={item.href}
                            onClick={item.onClick}
                        >
                            <Typography
                                component="span"
                                textAlign="left"
                                textStyle="h6"
                                color="inherit"
                            >
                                {item.label}
                            </Typography>
                        </Button>
                    ))}
                </FooterList>
                <Stack
                    gap="xl"
                    flexDirection="column"
                >
                    <FooterSocialList>
                        {socialLinks.map((link) => (
                            <FooterSocialLink
                                key={link.key}
                                href={link.href}
                                icon={link.icon}
                                label={link.label}
                            />
                        ))}
                    </FooterSocialList>
                    <FooterCountryList
                        currentCountry="FR"
                        omit
                    />
                </Stack>
            </FooterListContainer>

            <FooterText>
                <Typography textStyle="caption">{t("office", { address: fullAddress })}</Typography>
                <br />
                <Typography textStyle="caption">{t("saveEnergy")}</Typography>
            </FooterText>
        </Footer>
    )
}

AppFooter.messages = [
    "AppFooter",
    ...useCenterMenu.messages,
    ...useLeftMenu.messages,
    ...useSocialLinks.messages,
    ...useOfficeAddress.messages,
] as const
